import React, { memo, useMemo, useCallback } from "react"

import { useCurrency } from "../../../hooks/useCurrency"
import { useFunctions } from "../../../hooks/useFunctions"
import { useCheckoutContext } from "../../../hooks/useCheckout"
import { useCustomerContext } from "../../../hooks/useCustomer"
import { useCheckout } from "../../../hooks/useCheckout"
declare global {
  interface Window {
    ttq: any
  }
}
export const withCartCheckout = Component =>
  memo(
    ({
      name = "CartCheckout",
      additionalCheckoutButton,
      additionalGeneralFeatureContentsOne,
      additionalGeneralFeatureContentsTwo,
      additionalFooterText,
    }: any) => {
      const { formatCurrency } = useCurrency()
      const { count, checkoutUrl } = useCheckout()
      const { customer } = useCustomerContext()
      const { checkout } = useCheckoutContext()
      const { loading, checkoutMultipass } = useFunctions()

      const handleCheckout = useCallback(
        async e => {
          e.preventDefault()
          const isBrowser = typeof window !== `undefined`
          if (isBrowser) {
            const title = e.target.innerText
            window.ttq.track("ClickButton", {
              content_id: checkout.id,
              content_name: title,
            })
          }
          await checkoutMultipass(customer?.email, checkout.id, checkoutUrl)
        },
        [checkoutMultipass, customer, checkout, checkoutUrl]
      )

      const { subtotalPriceV2 } = checkout || {}
      const { amount, currencyCode } = subtotalPriceV2 || {}
      const subtotal = amount ? formatCurrency(Number(amount), currencyCode, 2) : ""

      Component.displayName = name
      return useMemo(
        () => (
          <Component
            subtotalPrice={subtotal}
            count={count}
            handleCheckout={handleCheckout}
            loading={loading}
            additionalCheckoutButton={additionalCheckoutButton}
            additionalGeneralFeatureContentsOne={additionalGeneralFeatureContentsOne}
            additionalGeneralFeatureContentsTwo={additionalGeneralFeatureContentsTwo}
            additionalFooterText={additionalFooterText}
          />
        ),
        [
          subtotal,
          count,
          handleCheckout,
          additionalCheckoutButton,
          additionalGeneralFeatureContentsOne,
          additionalGeneralFeatureContentsTwo,
          additionalFooterText,
          loading,
        ]
      )
    }
  )
